import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useUserContext } from 'app/user';
import FontIcon from 'packages/ui/FontIcon';

const Aside = styled('aside')`
  background-color: #f5f5f5;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  width: 250px;
  z-index: 9999;
  overflow-y: scroll;
`;

const MainWrapper = styled('div')`
  background-color: #fff;
  min-width: 1000px;
  overflow-x: auto;
`;

const Wrapper = styled.div`
  padding-right: 250px;
`;

const UserInfoWrapper = styled.div`
  align-items: center;
  display: flex;

  img {
    border-radius: 50%;
    height: 24px;
    margin-left: 10px;
    width: 24px;
  }

  span {
    font-size: 14px;
  }
`;

const UserWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
`;

const NavGroup = styled('div')`
  border-top: 1px solid #eee;
  padding: 20px 0;
`;

const Nav = styled('nav')`
  color: #777;

  small {
    display: block;
    font-size: 12px;
    margin-bottom: 5px;
    padding: 0 30px;
    color: #929292 !important;
  }

  a {
    color: inherit;
    display: block;
    font-size: 16px;
    padding: 10px 30px;
    -webkit-transition: all 300ms ease;
    transition: all 300ms ease;
    border-bottom: 2px solid #eaeaea;

    &:hover {
      color: #222;
      text-decoration: none !important;
    }
  }
`;

function User() {
  const user = useUserContext();

  return (
    <UserWrapper>
      <UserInfoWrapper>
        <FontIcon name="user" size="20px" />
        <span>{user.displayName}</span>
      </UserInfoWrapper>
    </UserWrapper>
  );
}

function Menu() {
  return (
    <Nav>
      <NavGroup>
        <small>کمپین‌های تبلیغاتی</small>
        <Link to="/campaigns">کمپین‌ها</Link>
        <Link to="/virgool">سفارش‌های ویرگول</Link>
        <Link to="/ads">سفارش‌های وندو</Link>
        <Link to="/search">جستجو در سفارشات</Link>
        <Link to="/events">رویداد ها</Link>
        <Link to="/recorded-videos">ویدیوهای ضبط شده</Link>
        <Link to="/webinar-status">وضعیت سرویس وبینار</Link>
        <Link to="/refunds">عودت‌ها</Link>
        <Link to="/user-stats">آمار</Link>
        <Link to="/attendees">شرکت کنندگان</Link>
        <Link to="/promotions">پروموشن‌ها</Link>
        <Link to="/bale-posts/new">پست بله</Link>
        <Link to="/evand-promot">پیام‌های ایوند</Link>
        <Link to="/credits">کردیت‌ها</Link>
        <Link to="/mentors">منتورها</Link>
        <Link to="/transactions">پرداخت‌ها</Link>
        <Link to="/sliders">اسلایدرها</Link>
        <Link to="/deposits">واریزی‌ها</Link>
        <Link to="/orders">سفارشات</Link>
        <Link to="/custom-orders">سفارشات دستی</Link>
        <Link to="/users">کاربران</Link>
        <Link to="/organizations">برگزارکنندگان</Link>
        <Link to="/circles">دایره‌ها</Link>
        <Link to="/circles/new">دایره جدید</Link>
        <Link to="/logs?include=event,user">لاگ ها</Link>
      </NavGroup>
    </Nav>
  );
}

function Layout({ children }) {
  return (
    <Wrapper>
      <Aside>
        <User />
        <Menu />
      </Aside>

      <MainWrapper>{children}</MainWrapper>
    </Wrapper>
  );
}

export default Layout;
